import { getModuleCache, hideDialog, setModuleCache, showDialog } from 'cw-ui-core';
import { legacy_connect as connect } from 'react-redux';
import AsioUpgradeDialog from './AsioUpgradeDialog';
import { FEEDBACK_DIALOG_ID } from '../Feedback/FeedbackDialogContainer';
import { ASIO_ENABLEMENT_DIALOG_ID } from '../AsioEnablementDialog/AsioEnablementDialogContainer';

export const ASIO_UPGRADE_DIALOG_ID = 'ASIO_UPGRADE';

const mapStateToProps = state => {
  return {
    isFullAccountUpgrade: getModuleCache(state.module, ['isFullAccountUpgrade']),
    isAutomateInAsioUpgrade: getModuleCache(state.module, ['isAutomateInAsioUpgrade'])
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onCloseIconClick: () => {
      dispatch(hideDialog(ASIO_UPGRADE_DIALOG_ID));
    },
    onNeedHelpClick: () => {
      dispatch(hideDialog(ASIO_UPGRADE_DIALOG_ID));
      dispatch(showDialog(FEEDBACK_DIALOG_ID, {
        returnToUpgradeDialogOnClose: true
      }));
    },
    onFullAccountUpgradeClick: () => {
      dispatch(setModuleCache('asioDialogActiveStep', 1));
      dispatch(hideDialog(ASIO_UPGRADE_DIALOG_ID));
      dispatch(showDialog(ASIO_ENABLEMENT_DIALOG_ID));
    },
    onAutomateInAsioUpgradeClick: () => {
      dispatch(setModuleCache('asioDialogActiveStep', 1));
      dispatch(hideDialog(ASIO_UPGRADE_DIALOG_ID));
      dispatch(showDialog(ASIO_ENABLEMENT_DIALOG_ID));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AsioUpgradeDialog);
